import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const isLinkUser = createSelector(
  (state: RootState) => state.application.customerGuid,
  (state: RootState) => state.application.organizationGuid,

  (customerGuid, organizationGuid) => !!(customerGuid && organizationGuid),
);
